import { useEffect, useState } from 'react';
import { toggleSetValue } from '@heraion/shared';

import type { ExercisePickerProps } from './pickerProps';

// #336 - the days ticked in «In which days» (pickerProps `addDays`). Every
// open starts from the day the picker was opened on, like the rest of the
// picker's selection. Without `addDays` it holds nothing and nobody reads it.
export function usePickerDays(
  visible: boolean,
  addDays: ExercisePickerProps['addDays'],
) {
  const current = addDays?.current;
  const [days, setDays] = useState<Set<number>>(() => new Set());
  useEffect(() => {
    if (visible) setDays(current === undefined ? new Set() : new Set([current]));
  }, [visible, current]);
  return {
    days,
    toggleDay: (day: number) => setDays((s) => toggleSetValue(s, day)),
    /** For `onAddMany`: in day order, or undefined without `addDays`. */
    chosen: (): number[] | undefined =>
      addDays ? [...days].sort((a, b) => a - b) : undefined,
  };
}
